<template>
  <div>
    <div v-if="! isModal" class="level is-variable bd-klmn-columns is-1 is-marginless">
      <div class="level-left">
        <b-tooltip :label="$t('clearFilter')" type="is-dark" position="is-right">
          <b-button
            class="filter-button is-hidden-mobile"
            size="is-circle"
            icon-left="filter-remove"
            @click="clearFilter"
          />
        </b-tooltip>
        <div class="filter-tags">
          <b-tag
            v-for="(filter, index) in filters"
            :key="index"
            type="is-purple"
            closable
            @close="removeFilter(filter)"
          >
            {{ $t('filter.vehicle_types.' + filter) }}
          </b-tag>
        </div>
      </div>
      <div class="level-right">
        <slot name="header-right" />
      </div>
    </div>
    <b-table
      :data="data"
      :loading="isLoading"

      :current-page.sync="page"
      :total="total"
      :per-page="perPage"

      :default-sort-direction="defaultSortOrder"
      :default-sort="[sortField, sortOrder]"
      striped
      sticky-header
      paginated
      hoverable
      backend-sorting
      backend-pagination

      aria-next-label="Next page"
      aria-previous-label="Previous page"
      aria-page-label="Page"
      aria-current-label="Current page"

      class="no-wrap custom-table"
      @page-change="onPageChange"
      @sort="onSort"
    >
      <template slot-scope="props">
        <b-table-column :label="$t('vehicleTypeName')" field="name" sortable centered>
          <template slot="header" slot-scope="{ column }">
            <b-dropdown aria-role="menu" class="search-dropdown" :close-on-click="false">
              <b-icon slot="trigger" icon="magnify" class="search-icon pointer" custom-size="mdi-20px" />
              <b-dropdown-item aria-role="menu-item" :focusable="false">
                <b-input v-model="queryData.name" :placeholder="$t('nameSearch')" size="is-small" autocomplete="off" type="search" />
              </b-dropdown-item>
            </b-dropdown>
            {{ column.label }}
          </template>
          {{ props.row.name }}
        </b-table-column>

        <b-table-column :label="$t('txtstatus')" field="is_active" sortable centered>
          <template slot="header" slot-scope="{ column }">
            <b-dropdown v-model="queryData.is_active" aria-role="list" :close-on-click="false">
              <b-icon slot="trigger" icon="magnify" class="search-icon pointer" custom-size="mdi-20px" />
              <b-dropdown-item value="1" aria-role="listitem">
                <span>{{ $t('itemStatus.true') }}</span>
              </b-dropdown-item>
              <b-dropdown-item value="0" aria-role="listitem">
                <span>{{ $t('itemStatus.false') }}</span>
              </b-dropdown-item>
            </b-dropdown>
            {{ column.label }}
          </template>
          <b-switch
            v-model="props.row.is_active"
            type="is-purple"
            @input="statusSwitch(props.row)"
          >
            {{ $t(`itemStatus.${props.row.is_active}`) }}
          </b-switch>
        </b-table-column>

        <b-table-column label="Oluşturulma Tarihi" field="created_at" sortable date centered>
          <template slot="header" slot-scope="{ column }">
            <b-dropdown aria-role="menu" class="date-search search-dropdown" :close-on-click="false">
              <b-icon slot="trigger" icon="magnify" class="search-icon pointer" custom-size="mdi-20px" />
              <b-dropdown-item custom paddingless aria-role="menu-item" :focusable="false">
                <b-datepicker
                  v-model="queryData.created_at_range"
                  :placeholder="$t('dateSearch')"
                  :first-day-of-week="1"
                  :month-names="$t('dateTimePicker.monthNames')"
                  :day-names="$t('dateTimePicker.dayNames')"
                  icon="calendar-today"
                  range
                  inline
                >
                  <div class="button is-danger" @click="queryData.created_at_range = []">
                    {{ $t('clear') }}
                  </div>
                </b-datepicker>
              </b-dropdown-item>
            </b-dropdown>
            {{ column.label }}
          </template>
          <small class="tag is-abbr-like" :title="props.row.created_at">
            {{ props.row.created_at | formatDate }}
          </small>
        </b-table-column>
      </template>

      <template slot="bottom-left">
        <div v-if="total > 0" class="has-text-left subtitle help">
          {{ $t('paginationShowing', [total.toLocaleString(), ((page * perPage) - perPage) + 1, ((page * perPage) > total ? total : (page * perPage)) ]) }}
        </div>
      </template>

      <section slot="empty" class="section">
        <div class="content has-text-grey has-text-centered">
          <template v-if="!isLoading">
            <p>
              <b-icon icon="table" size="is-large" />
            </p>
            <p>{{ $t('nodata') }}</p>
          </template>
        </div>
      </section>
    </b-table>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
import download from 'downloadjs'
import debounce from 'lodash/debounce'
import $ from 'jquery'

export default {
  props: {
    dataUrl: {
      type: String,
      default: null
    },
    checkable: {
      type: Boolean,
      default: false
    },
    isModal: {
      type: Boolean,
      default: false
    },
    where: {
      type: Object,
      default: () => {}
    },
  },
  data () {
    return {
      isDepartmentModalActive: false,
      departmentId: null,
      data: [],
      isLoading: false,
      perPage: 50,
      sortField: 'id',
      sortOrder: 'desc',
      defaultSortOrder: 'desc',
      total: 0,
      page: 1,
      count: 0,
      inputTrigger: null,
      queryData: {
        name: '',
        is_active: '',
        created_at_range: [],
        excel: false,
      },
      filters: [],
    }
  },
  computed: {
    ...mapState([
      'boardRefresh',
    ]),
    departmentTarget () {
      if (this.isModal) {
        return '_blank'
      }

      return '_self'
    },
  },
  watch: {
    query () {
      this.filterAction()
    },
    queryData: {
      handler () {
        this.filterAction()
      },
      deep: true
    },
    'queryData.created_at_range' () {
      setTimeout(function () {
        $('body').trigger('click');
      }, 250);
    },
    boardRefresh (n) {
      if (n == true) {
        this.loadVehicleTypes()
      }
    }
  },
  mounted () {
    if (this.where) {
      this.queryData = this.$_.merge(this.queryData, this.where);
    }
    this.isLoading = true
    this.loadVehicleTypes()
  },
  methods: {
    filterAction: debounce(function () {
      this.filterShow()
      this.loadVehicleTypes()
    }, 350),
    clearFilter () {
      this.queryData = {
        name: '',
        is_active: '',
        created_at_range: [],
        excel: false,
      }

      this.filterShow()
    },
    loadVehicleTypes () {
      if (!this.dataUrl) {
        return
      }

      this.$emit('loadingChange', true)

      this.$http({
        url: this.dataUrl,
        method: 'GET',
        responseType: this.queryData.excel ? 'blob' : 'json',
        params: {
          ...this.queryData,
          sort_by: this.sortField,
          sort_order: this.sortOrder,
          page: this.page,
          created_at_range: this.queryData.created_at_range.length === 2
            ? [moment(this.queryData.created_at_range[0]).format('YYYY-MM-DD'), moment(this.queryData.created_at_range[1]).format('YYYY-MM-DD')]
            : null,
        },
      }).then(({ data }) => {
        if (this.queryData.excel) {
          download(data, `departments-${moment().format('DD-MM-YYYY-h-mm')}.xlsx`, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
          this.isLoading = false
          this.$emit('excelChange', false)
          this.$emit('loadingChange', false)
          this.queryData.excel = false
          return false
        }

        this.data = data.data ?? []
        this.total = data.meta.total ?? 0
        this.perPage = data.meta.per_page ?? this.perPage
        this.page = data.meta.current_page ?? this.page
        this.count = data.meta.to ?? this.count

        if (data.data.length > 0) {
          window.scrollTo(0, 0)
        }
      }).catch(e => {
        this.data = []
        this.$buefy.toast.open({
          message: `Error: ${e.message}`,
          type: 'is-danger'
        })
      }).then(() => {
        this.$nextTick(() => {
          this.isLoading = false
          this.$emit('loadingChange', false)

          this.$store.commit('boardRefresh', false)
          this.jqInputTrigger()
        })
      })
    },
    jqInputTrigger () {
      if (this.inputTrigger) return;

      $('.dropdown-trigger').click(function (e) {
        e.stopPropagation()
        $(this).parent().find('input, select').first().focus()
      })
      $('.search-dropdown input').keypress(function (e) {
        if (e.which == '13') {
          $('body').trigger('click')
        }
      });
      $('.dropdown').click(function (e) {
        e.stopPropagation()
      })
      this.inputTrigger = true;
    },
    onPageChange (page) {
      this.page = page
      this.loadVehicleTypes()
    },
    onSort (field, order) {
      this.page = 1
      this.sortField = field
      this.sortOrder = order
      this.loadVehicleTypes()
    },
    filterShow () {
      this.filters = this.$_.keys(this.$_.omitBy(this.queryData, this.$_.isEmpty))
    },
    removeFilter (filter) {
      this.queryData[filter] = this.$_.isArray(this.queryData[filter]) ? [] : ''
      this.filterShow()
    },
    exportExcel () {
      this.queryData.excel = true
    },
    statusSwitch ({ id, is_active }) {
      this.isLoading = true

      this.$http.put('vehicle-types/' + id, { is_active }).then(() => {
        //
      }).catch(e => {
        const errors = this.$_.flattenDeep(this.$_.values(e.response.data.error.errors)).join('<br>')

        this.$buefy.toast.open({
          message: this.$t('error') + ': <br>' + errors,
          type: 'is-warning',
          duration: 5000,
        })
      }).finally(() => {
        this.isLoading = false
      })
    },
  }
}
</script>
